<div>
    <webcam *ngIf="!error" [height]="300" [width]="300" [trigger]="imageTrigger" (imageCapture)="captureImage($event)"
        (initError)="handleInitError($event)"></webcam>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" style="margin-top: 8px;" (click)="triggerSnapshot()" [disabled]="!!error">Capture</button>
</div>